import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _defineProperty from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import "core-js/modules/es7.object.values.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.assign.js";
import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import cloneDeep from 'lodash/cloneDeep';
import Logger from 'js-logger';
import { isValidPastDate } from '@/functions/validators';
import { make } from 'vuex-pathify';
import moment from 'moment';
import transactions from '@/store/helpers/transactions';
import Voucher from '@/store/helpers/voucher';
import Vue from 'vue';
import { i18n } from '@/boot/i18n';

var defaultState = function defaultState() {
  return {
    branches: null,
    visitDetails: {
      datetime: null
    },
    demoReceipt: {
      items: [{
        id: 1,
        name: 'Pad thai curry',
        quantity: 1,
        value: '10.12'
      }, {
        id: 2,
        name: 'Prawn curry',
        quantity: 1,
        value: '8.15'
      }, {
        id: 3,
        name: 'X-small white wine',
        quantity: 2,
        value: '7.00'
      }, {
        id: 4,
        name: 'Reg Coca-Cola Classic',
        quantity: 2,
        value: '18.13'
      }],
      total: 33.4,
      feedbackCode: '786-954-123'
    },
    digitalReceiptAvailable: false,
    eposData: null,
    fetchedSlug: '',
    startTime: null,
    guid: '',
    returnedLocation: null,
    showAboutVisit: true,
    // always true for now unless backend altered to accommodate
    tableNumber: null,
    transactionRef: null,
    urlParams: null,
    nextPage: null,
    nonAppStaff: null,
    // Staff content available for use away from the app (the app already has its own store)
    nonAppStaffBranchId: null,
    // The branch the cached nonAppStaff were fetched for
    voucher: null
  };
};

var state = defaultState();

var actions = _objectSpread(_objectSpread({}, make.actions(state)), {}, {
  // Make default actions

  /**
   * Fetch branches for location picker.
   *
   * @param {Object} context Vuex module context
   *
   * @returns {Void}
   */
  fetchBranches: function fetchBranches(_ref) {
    var _arguments = arguments,
        _this = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var commit, state, slug, usedSlug, headers, returnedLocation, res, branches;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit, state = _ref.state;
              slug = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : '';
              usedSlug = slug || state.urlParams.slug;
              headers = {
                'X-FIB-API-TEMPLATE-SLUG': slug || state.urlParams.slug
              };
              commit('fetchedSlug', usedSlug);
              returnedLocation = state.returnedLocation;

              if (!(returnedLocation && returnedLocation.coords)) {
                _context.next = 12;
                break;
              }

              _context.next = 9;
              return _this.$api.fetchBranches({
                lng: returnedLocation.coords.longitude,
                lat: returnedLocation.coords.latitude
              }, headers);

            case 9:
              _context.t0 = _context.sent;
              _context.next = 15;
              break;

            case 12:
              _context.next = 14;
              return _this.$api.fetchBranches(null, headers);

            case 14:
              _context.t0 = _context.sent;

            case 15:
              res = _context.t0;
              // TODO: Pagination of branch results need to be implemented
              branches = res && res.data && res.data.branches ? res.data.branches : null;
              commit('setBranches', branches);

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },

  /**
   * Download config data into the store
   *
   * @param {Object} context Vuex module context
   *
   * @returns {Boolean} True when successful, false otherwise
   */
  fetchConfig: function fetchConfig(_ref2, _ref3) {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var commit, dispatch, _ref3$slug, slug, _ref3$showError, showError, edges, config;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref2.commit, dispatch = _ref2.dispatch;
              _ref3$slug = _ref3.slug, slug = _ref3$slug === void 0 ? '' : _ref3$slug, _ref3$showError = _ref3.showError, showError = _ref3$showError === void 0 ? true : _ref3$showError;
              // Start the config download
              Logger.debug('Start config download (CheckIn)'); // Not sure if we need all these edges - questions and staff need branch info

              edges = ['complaints', 'core', 'data_capture', 'demographics', 'statics', 'surveys'];
              _context2.next = 6;
              return _this2.$api.fetchConfig(edges, {
                'X-FIB-API-TEMPLATE-SLUG': slug
              }, showError);

            case 6:
              config = _context2.sent;
              commit('fetchedSlug', slug); //Logger.debug('Download result:', config)

              if (!(!config || config.error)) {
                _context2.next = 11;
                break;
              }

              Logger.warn('Failed to download config');
              return _context2.abrupt("return", false);

            case 11:
              // Save the config data
              Logger.debug('Save config');
              commit('config/companyKey', config.data.core.company.keyName, {
                root: true
              });
              dispatch('config/commitConfig', config.data, {
                root: true
              });
              commit('surveys/surveys', config.data.surveys, {
                root: true
              });
              return _context2.abrupt("return", true);

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },

  /**
   * Download question data into the store, only possible when the location is known.
   *
   * We will have to revisit this, as we will also take the opportunity to download
   * the branch information at this point because we haven't had a chance to get this yet.
   *
   * @param {Object} context Vuex module context
   *
   * @returns {Boolean} True when successful, false otherwise
   */
  fetchBranchConfig: function fetchBranchConfig(_ref4) {
    var _arguments2 = arguments,
        _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var commit, dispatch, rootState, rootGetters, slug, branchConfig;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref4.commit, dispatch = _ref4.dispatch, rootState = _ref4.rootState, rootGetters = _ref4.rootGetters;
              slug = _arguments2.length > 1 && _arguments2[1] !== undefined ? _arguments2[1] : '';
              // Start the questions download
              Logger.debug('Start branch config download');
              _context3.next = 5;
              return _this3.$api.fetchConfig(['questions', 'branch'], {
                'X-FIB-API-TEMPLATE-SLUG': slug
              });

            case 5:
              branchConfig = _context3.sent;
              Logger.debug('Download result:', branchConfig);

              if (!(!branchConfig || branchConfig.error)) {
                _context3.next = 10;
                break;
              }

              Logger.warn('Failed to download branch config');
              return _context3.abrupt("return", false);

            case 10:
              // Save all branch config data
              Logger.debug('Save branch config');
              commit('surveys/questions', branchConfig.data.questions, {
                root: true
              });
              commit('config/branchDetails', branchConfig.data.branch, {
                root: true
              });
              return _context3.abrupt("return", true);

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },

  /**
   * Fetch transaction data and return if available
   *
   * @param {Object} context Vuex module context
   *
   * @returns {Boolean} Success ? true : false
   */
  fetchTransactionData: function fetchTransactionData(_ref5, isTableNumber) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var state, commit, rootGetters, validData;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              state = _ref5.state, commit = _ref5.commit, rootGetters = _ref5.rootGetters;
              _context4.next = 3;
              return transactions.fetchTransactionData(isTableNumber);

            case 3:
              validData = ((state.eposData || {}).pin || {}).validData;

              if (!(!(state.eposData || {}).transaction || validData !== '1')) {
                _context4.next = 9;
                break;
              }

              if (rootGetters['errors/error']) {
                _context4.next = 7;
                break;
              }

              return _context4.abrupt("return", validData === '1' && !state.eposData.transaction ? {
                error: i18n.t("error.".concat(isTableNumber ? 'tableNumber' : 'pin', ".NO-TRANSACTION-DATA"))
              } : {
                error: i18n.t("error.".concat(isTableNumber ? 'tableNumber' : 'pin', ".").concat(validData || 'INVALID-PIN'))
              });

            case 7:
              commit('checkIn/resetState');
              return _context4.abrupt("return");

            case 9:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  },
  setTransactionRef: function setTransactionRef(_ref6) {
    var _arguments3 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var commit, dispatch, rootState, rootGetters, pin;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              commit = _ref6.commit, dispatch = _ref6.dispatch, rootState = _ref6.rootState, rootGetters = _ref6.rootGetters;
              pin = _arguments3.length > 1 && _arguments3[1] !== undefined ? _arguments3[1] : null;
              commit('setTransactionRef', pin);

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  },

  /**
   *
   * @param {Object} context Vuex module context
   * @param {Object} params
   *
   * @returns {Void}
   */
  cleanParams: function cleanParams(_ref7) {
    var _arguments4 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var commit, dispatch, rootState, rootGetters, params, urlParams, falseyKeys, shortHandParams, nonMapped, key, value, val, survey, eposParams;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              commit = _ref7.commit, dispatch = _ref7.dispatch, rootState = _ref7.rootState, rootGetters = _ref7.rootGetters;
              params = _arguments4.length > 1 && _arguments4[1] !== undefined ? _arguments4[1] : {};
              Logger.debug('Clean the params', params);
              urlParams = {};
              falseyKeys = ['noVisit'];
              shortHandParams = {};
              nonMapped = ['branchId', 'dateTime', 'pin', 'pve', 'slug', 'urlSrc', 'inBranch', 'partnerKey', 'guestRef', 'txSource'].concat(Object.values(shortHandParams));

              for (key in params) {
                if (falseyKeys.includes(key)) {
                  urlParams[key] = true;
                } else {
                  value = params[key];

                  if (nonMapped.includes(key)) {
                    val = value;

                    if (key === 'urlSrc' && Array.isArray(value)) {
                      val = value.join('|');
                    }

                    urlParams[key] = val;
                  } else if (Object.prototype.hasOwnProperty.call(shortHandParams, key)) {
                    urlParams[shortHandParams[key]] = value;
                  }
                }
              }

              if ((urlParams['inBranch'] || false) && (urlParams['branchId'] || 0) > 0) {
                if (!(urlParams['dateTime'] || false)) {
                  survey = rootGetters['surveys/currentSurvey'];

                  if ((survey === null || survey === void 0 ? void 0 : survey.averageServiceTime) > 0) {
                    urlParams['dateTime'] = moment().subtract({
                      minutes: survey.averageServiceTime
                    }).format('YYYY-MM-DD HH:mm');
                  }
                }
              } else {
                delete urlParams['inBranch'];
              }

              _context6.next = 11;
              return transactions.cleanParams(params);

            case 11:
              eposParams = _context6.sent;
              urlParams = _objectSpread(_objectSpread({}, urlParams), eposParams);
              _context6.next = 15;
              return dispatch('setTransactionRef', urlParams.pve || urlParams.pin || null);

            case 15:
              if (urlParams['dateTime'] == 'now' || urlParams['noVisit']) {
                urlParams['dateTime'] = moment().format('YYYY-MM-DD HH:mm');
                urlParams['noVisit'] = true;
              }

              commit('setParams', urlParams);

            case 17:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }))();
  },
  setUrlParams: function setUrlParams(_ref8) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      var commit, dispatch, rootState, urlParams;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              commit = _ref8.commit, dispatch = _ref8.dispatch, rootState = _ref8.rootState;
              urlParams = rootState.checkIn.urlParams; // Set dateTime

              if (urlParams['dateTime']) {
                commit('setVisitDatetime', urlParams['dateTime']);
              } // set BranchId


              if (!urlParams['branchId']) {
                _context7.next = 8;
                break;
              }

              _context7.next = 6;
              return dispatch('config/setBranchByField', {
                id: urlParams['branchId'],
                field: 'id'
              }, {
                root: true
              });

            case 6:
              _context7.next = 16;
              break;

            case 8:
              if (!urlParams['locationId']) {
                _context7.next = 13;
                break;
              }

              _context7.next = 11;
              return dispatch('config/setBranchByField', {
                id: urlParams['locationId'],
                field: 'locationId'
              }, {
                root: true
              });

            case 11:
              _context7.next = 16;
              break;

            case 13:
              if (!urlParams['siteId']) {
                _context7.next = 16;
                break;
              }

              _context7.next = 16;
              return dispatch('config/setBranchByField', {
                id: urlParams['siteId'],
                field: 'siteId'
              }, {
                root: true
              });

            case 16:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }))();
  },
  nextPage: function nextPage(_ref9) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
      var _state$visitDetails;

      var commit, dispatch, state, rootState, datetime, visitDetailsValid;
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              commit = _ref9.commit, dispatch = _ref9.dispatch, state = _ref9.state, rootState = _ref9.rootState;

              if (rootState.config.branchDetails) {
                _context8.next = 4;
                break;
              }

              Logger.debug('branch details NOT stored, redirecting to find venue');
              return _context8.abrupt("return", '/check_in/find_venue');

            case 4:
              // if no valid visit details, redirect to about visit
              datetime = cloneDeep((_state$visitDetails = state.visitDetails) === null || _state$visitDetails === void 0 ? void 0 : _state$visitDetails.datetime);
              visitDetailsValid = isValidPastDate(datetime); // if config set to show about visit, show it

              if (!(!visitDetailsValid && state.showAboutVisit)) {
                _context8.next = 9;
                break;
              }

              Logger.debug('no valid visit details, redirecting to about visit');
              return _context8.abrupt("return", '/check_in/about_visit');

            case 9:
              // Clear the responses sending variable
              commit('responses/sending', false, {
                root: true
              });
              return _context8.abrupt("return", '/questions');

            case 11:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }))();
  },
  setTransactionData: function setTransactionData(_ref10, params) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
      var commit, dispatch, rootState;
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              commit = _ref10.commit, dispatch = _ref10.dispatch, rootState = _ref10.rootState;

              if (params.transaction) {
                commit('setTransactionData', params.transaction);
              }

            case 2:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }))();
  },
  setVisitDatetime: function setVisitDatetime(_ref11, datetime) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
      var commit;
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              commit = _ref11.commit;
              commit('setVisitDatetime', datetime);

            case 2:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }))();
  },

  /**
   * Fetch & store staff data available for use within a survey only when required, abstracting over the source of data.
   *
   * @param {Function} commit Vuex module commit
   * @param {Object} state Vuex module getters
   * @param {Object} state Vuex module rootState
   *
   * @returns {Array}
   */
  fetchStaff: function fetchStaff(_ref12) {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
      var commit, state, getters, rootGetters, rootState, branchId, _staff$data, staff;

      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              commit = _ref12.commit, state = _ref12.state, getters = _ref12.getters, rootGetters = _ref12.rootGetters, rootState = _ref12.rootState;

              if (rootGetters['config/isApp']) {
                _context11.next = 11;
                break;
              }

              branchId = rootState.config.branchId; // Staff are only ever served for a single branch, so a change of branch (e.g. a guest picking
              // a different venue mid-session) must invalidate the cache. Without this the guest is offered
              // another venue's team and their applaud is submitted against this branch.

              if (!(state.nonAppStaff === null || state.nonAppStaffBranchId !== branchId)) {
                _context11.next = 9;
                break;
              }

              _context11.next = 6;
              return _this4.$api.fetchConfig(['staff'], {
                'X-FIB-API-TEMPLATE-SLUG': state.urlParams.slug
              });

            case 6:
              staff = _context11.sent;
              commit('nonAppStaff', ((_staff$data = staff.data) === null || _staff$data === void 0 ? void 0 : _staff$data.staff) || []); // If we get nothing back, at least store an empty array to prevent re-requesting.

              commit('nonAppStaffBranchId', branchId);

            case 9:
              _context11.next = 12;
              break;

            case 11:
              return _context11.abrupt("return", rootGetters['config/config'].staff);

            case 12:
              return _context11.abrupt("return", getters.getStaff);

            case 13:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }))();
  },

  /**
   * Select the voucher available on the checkout page. It's very important that we only compute this
   * once per survey in order to avoid guests refreshing until they get the voucher they want.
   *
   * @param {Function} commit Vuex module commit
   * @param {Object} state Vuex module state
   * @param {Object} rootGetters Vuex module rootGetters
   */
  selectVoucher: function selectVoucher(_ref13) {
    var commit = _ref13.commit,
        state = _ref13.state,
        rootGetters = _ref13.rootGetters;

    // If the commit has already run, state.voucher will be set to { selected }, and this is to avoid
    // being run again in the case it returns null (no voucher selected).
    if (state.voucher) {
      return;
    }

    var selected = Voucher.select(rootGetters['surveys/currentSurvey'].vouchers);
    commit('setSelectedVoucher', selected);
  }
});

var getters = _objectSpread(_objectSpread({}, make.getters(state)), {}, {
  // Make default getters

  /**
   * Returns visit details or null if unavailable.
   *
   * @param {Object} state Vuex module state
   *
   * @returns {Object} Visit details
   */
  getVisitDetails: function getVisitDetails(state) {
    return state.visitDetails || null;
  },

  /**
   * Identifies if the current survey has transaction data
   *
   * @param {Object} state Vuex module state
   *
   * @returns {Boolean}
   */
  hasTransaction: function hasTransaction(state) {
    var _state$eposData, _state$eposData$trans;

    // We identify this based on the presence of a check.
    return !!((_state$eposData = state.eposData) !== null && _state$eposData !== void 0 && (_state$eposData$trans = _state$eposData.transaction) !== null && _state$eposData$trans !== void 0 && _state$eposData$trans.check);
  },

  /**
   * Get all products present in the epos transaction.
   *
   * @param {Object} state Vuex module state
   *
   * @param {Boolean} properOnly Whether to return just 'proper' menu items (with the proper flag set)
   * or all. You almost always want this defaulted.
   *   Proper products (which have the proper flag set to true) are what the API generally considers
   * as 'presentable' to the guest - i.e. they're non-modifiers with a valid price (this is subject
   * to change per epos type - but the front-end doesn't need to worry about that as long as they just
   * use this flag).
   *
   * @returns {Array}
   */
  transactionProducts: function transactionProducts(state) {
    return function () {
      var _state$eposData2, _state$eposData2$tran, _state$eposData2$tran2;

      var properOnly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return ((_state$eposData2 = state.eposData) === null || _state$eposData2 === void 0 ? void 0 : (_state$eposData2$tran = _state$eposData2.transaction) === null || _state$eposData2$tran === void 0 ? void 0 : (_state$eposData2$tran2 = _state$eposData2$tran.menuItems) === null || _state$eposData2$tran2 === void 0 ? void 0 : _state$eposData2$tran2.filter(function (m) {
        return !properOnly || m.proper;
      })) || [];
    };
  },

  /**
   * Get staff available for use within a survey, abstracting over the source of data
   *
   * @param {Object} state Vuex module state
   * @param {Object} state Vuex module getters
   * @param {Object} state Vuex module rootState
   *
   * @returns {Array}
   */
  getStaff: function getStaff(state, getters, rootState) {
    return (rootState.config.isApp ? rootState.manageTeam.teamMembersOrderedByWeight : state.nonAppStaff) || [];
  }
});

var mutations = _objectSpread(_objectSpread({}, make.mutations(state)), {}, {
  // Make default mutations

  /**
   * Reset the module state back to its default.
   *
   * @param {Object} state Vuex module state
   *
   * @returns {Void}
   */
  resetState: function resetState(state) {
    Object.assign(state, defaultState());
  },

  /**
   * Set branch data
   *
   * @param {Object} state Vuex module state
   * @param {Object} branches Branches
   *
   * @returns {Void}
   */
  setBranches: function setBranches(state) {
    var branches = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    Vue.set(state, 'branches', branches);
  },

  /**
   *
   * @param {Object} state Vuex module state
   * @param {Object} params Key value pairs to store in the checkin.urlParams
   */
  setParams: function setParams(state) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    Vue.set(state, 'urlParams', params);
  },

  /**
   * Set transaction data.
   *
   * @param {Object} state Vuex module state
   * @param {Object} transactionData Transaction data
   *
   * @returns {Void}
   */
  setTransactionData: function setTransactionData(state) {
    var transactionData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    state.eposData = transactionData;

    if (transactionData.pveQueueId) {
      state.urlParams.pveQueueId = transactionData.pveQueueId;
    }
  },

  /**
   * Set transactionRef.
   *
   * @param {Object} state Vuex module state
   * @param {Number} transactionRef
   *
   * @returns {Void}
   */
  setTransactionRef: function setTransactionRef(state) {
    var transactionRef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    state.transactionRef = transactionRef || '';
  },

  /**
   *
   * @param {Object} state Vuex module state
   * @param {String} datetime
   */
  setVisitDatetime: function setVisitDatetime(state, datetime) {
    // force the storing of a moment object
    var dateFormats = ['MM-DD-YYYY HH:mm', 'MM-DD-YYYY HH:mm:ss', 'YYYY-MM-DD HH:mm', 'YYYY-MM-DD HH:mm:ss', 'DD-MM-YYYY HH:mm', 'DD-MM-YYYY HH:mm:ss'];
    datetime = datetime instanceof moment ? datetime : moment(datetime, dateFormats, true);

    if (datetime.isValid()) {
      state.visitDetails.datetime = datetime;
    }
  },

  /**
   * Set selected voucher
   *
   * @param {Object} state Vuex module state
   * @param {Object} selected selected voucher
   */
  setSelectedVoucher: function setSelectedVoucher(state, selected) {
    state.voucher = {
      selected: selected
    };
  }
});

export default {
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations,
  namespaced: true
};